import React from "react";
import { useParams } from "react-router-dom";
import { useAppSelector } from "src/store/store";
import AuditLayout from "./AuditLayout";
import AuditWorkspace from "../workspace/AuditWorkspace";

/** Wrapper that passes the route taskId into AuditLayout so the sidebar highlights Workspace. */
export const WorkspaceWithLayout: React.FC = () => {
  const { taskId } = useParams<{ taskId: string }>();
  return (
    <AuditLayout activeTaskId={taskId}>
      <AuditWorkspace />
    </AuditLayout>
  );
};

/** Wrapper for non-workspace audit pages — reads lastActiveTaskId from Redux so the
 *  Workspace nav item stays clickable after navigating away from the workspace. */
export const AuditPageLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const lastActiveTaskId = useAppSelector((state) => state.auditWorkspaceSlice.lastActiveTaskId);
  return <AuditLayout activeTaskId={lastActiveTaskId ?? undefined}>{children}</AuditLayout>;
};
